/** Last row is open; chunks and newlines extend canonical data in place. */
export function appendTerminalChunk(lines: string[], chunk: string): void {
  const pieces = chunk.split("\n");
  if (lines.length === 0) lines.push(pieces[0]);
  else lines[lines.length - 1] += pieces[0];
  for (let index = 1; index < pieces.length; index++) lines.push(pieces[index]);
}
